import { render, staticRenderFns } from "./screenList-2.vue?vue&type=template&id=3814699a&scoped=true"
import script from "./screenList-2.vue?vue&type=script&lang=js"
export * from "./screenList-2.vue?vue&type=script&lang=js"
import style0 from "./screenList-2.vue?vue&type=style&index=0&id=3814699a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814699a",
  null
  
)

export default component.exports